// extracted by mini-css-extract-plugin
export var currencyInput = "_ab-1";
export var currencySymbol = "_ab-0";